import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import CardService from 'services/CardsService';
import { setNextAvailable } from 'actions/timer';
import { putIn } from 'actions/storylet';
import computeNextActionsAt from 'utils/computeNextActionsAt';

import {
  BACKGROUND_FETCH_CARDS_REQUESTED,
  CARDS_SHOULD_FETCH,
  FETCH_CARDS_FAILURE,
  FETCH_CARDS_REQUESTED,
  FETCH_CARDS_SUCCESS,
} from 'actiontypes/cards';
import { ICardsService } from 'types/cards';
import { IAppState } from 'types/app';

const fetchRequested = (background: boolean) => ({
  type: background ? BACKGROUND_FETCH_CARDS_REQUESTED : FETCH_CARDS_REQUESTED,
});

export const fetchSuccess = (data: any) => ({ type: FETCH_CARDS_SUCCESS, payload: data });

export const shouldFetch = () => ({ type: CARDS_SHOULD_FETCH });

const fetchFailure = (error: any) => ({
  type: FETCH_CARDS_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

export default fetch(new CardService());

/** ----------------------------------------------------------------------------
 * FETCH CARDS
 * preventMove bool - HS parameter to stop the loading of opp cards moving player out of
 * storylet end. Bit of a hack. Sorry.
 -----------------------------------------------------------------------------*/
export function fetch(service: ICardsService) {
  return ({ background = false, preventMove = false } = {}) => async (dispatch: Function, getState: () => IAppState) => {
    const { cards: { isFetching, isFetchingInBackground } } = getState();

    if (isFetching || isFetchingInBackground) {
      return undefined;
    }

    dispatch(fetchRequested(background));

    try {
      const { data } = await service.fetchOpportunityCards();
      const { currentTime, nextActionAt } = data;

      // If the updated card data says we're in a storylet, and this wasn't a background fetch,
      // and we're not explicitly prevented from moving, then move us to the 'In' phase
      if (!preventMove && data.isInAStorylet && !background) {
        dispatch(putIn());
      }

      // We may have new timer data incoming, so update the timer state slice
      const nextActionsAt = computeNextActionsAt({ currentTime, nextActionAt });
      dispatch(setNextAvailable(nextActionsAt));

      dispatch(fetchSuccess(data));
      return data;
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }

      dispatch(fetchFailure(error));
      return error;
    }
  };
}